import { noop } from '@proc7ts/primitives';
import { zExecutionDone } from './exec-done.impl.js';
/**
 * @internal
 */
const noopZExecution = {
    whenStarted() {
        return zExecutionDone;
    },
    whenDone() {
        return zExecutionDone;
    },
    abort: noop,
};
/**
 * Performs no-op execution.
 *
 * @typeParam TResult  Execution result type.
 *
 * @returns Already completed execution instance.
 */
export function execZNoOp() {
    return noopZExecution;
}
//# sourceMappingURL=exec-noop.js.map